import React from 'react';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

export default class OperationHours extends React.Component {
    constructor(props, params) {
        super(props, params);
        this.state = { showMoreHours: false };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.OperationHours.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { pharmacy } = this.props;
        const icon = pharmacy && pharmacy.OperationHours && pharmacy.OperationHours.Display && pharmacy.OperationHours.Display.Today && pharmacy.OperationHours.Display.Today.toUpperCase() === "PERMANENTLY CLOSED" ? null : (this.state.showMoreHours ? <span className="icon-dd-up" /> : <span className="icon-dd" />);
        return (
            <div className="operating-hours">
                <div className="details-icon-prepend">
                    <div className="icon-col">
                        <span className="icon-clock" />
                    </div>
                    {pharmacy.OperationHours ?
                        <div className="details-col" onClick={() => this.setState({ showMoreHours: !this.state.showMoreHours })}>
                            <div className="currentHours">
                                <span className="current-times">{pharmacy.OperationHours.Display.Today}</span>{icon}
                            </div>
                            {this.state.showMoreHours &&
                                pharmacy.OperationHours.OperationTimings.map((item, index) =>
                                    <div className="addtlHours" key={index}>
                                        <div>
                                            <span className="hours-day">{item.Days}</span>
                                            <span className="hours-time">{item.Hours} </span>
                                        </div>
                                    </div>
                                )}
                        </div> :
                        <div className="details-col">
                            <div className="no-data-dash">
                                <div />
                            </div>
                        </div>
                    
                       }

                </div>
            </div>
        );
    }
}